import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Meddelanden", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"card card-feat\"><div class=\"card-body\"><div class=\"row\"><div class=\"col\"><h1 class=\"h2 mb-3 text-center\">Du har inga nya meddelande</h1><p>Meddelanden som är äldre än 30 dagar syns ej.</p></div></div></div></div>", 1)
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "card card-feat" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Ärende: ", -1)
const _hoisted_17 = {
  key: 0,
  class: "badge rounded-pill bg-success"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Ämne: ", -1)
const _hoisted_20 = {
  key: 0,
  class: "badge rounded-pill bg-success"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Meddelande: ")
], -1)
const _hoisted_22 = {
  class: "mb-2",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded && _ctx.messages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
                _ctx.$router.push('/message/add');
              }),
              class: "btn btn-primary"
            }, " Nytt meddelande ")
          ]),
          _hoisted_7
        ])),
    (_ctx.loaded && _ctx.messages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
                _ctx.$router.push('/message/add');
                _ctx.markAsReadList(_ctx.messages);
              }),
                  class: "btn btn-primary"
                }, " Nytt meddelande ")
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.id,
                  class: "mb-3"
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      (message.loanType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.geLoanType(message.loanType)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (message.category)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(_toDisplayString(message.category) + " ", 1),
                            (!message.isRead)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Nytt"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(_toDisplayString(message.subject) + " ", 1),
                            (!message.isRead && !message.fromCustomer)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Nytt"))
                              : _createCommentVNode("", true)
                          ])),
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(message.fromCustomer ? "Skickat: " : "Mottaget: "), 1),
                        _createTextVNode(_toDisplayString(_ctx.formatDate(message.createdAt)), 1)
                      ]),
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString(message.message), 1),
                      (!message.fromCustomer && index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => {
                      _ctx.$router.push('/message/add');
                      _ctx.markAsRead(message.id);
                    },
                              class: "btn btn-outline btn-sm"
                            }, " Svara ", 8, _hoisted_24)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}